import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import Cookies from 'js-cookie';

import { getElementHeight, getVisibleHeight } from 'utils/browser';
import { setLanguage } from '../locale/ducks';

import Header from './Header';
import Footer from './Footer';
import MainContent from './MainContent';
import Sidebar from './Sidebar';

class Root extends Component {
  constructor(props, context) {
    super(props, context);

    const visibleHeight = getVisibleHeight();
    let lang = 'is';
    const langCookie = Cookies.get('userCulture');
    if (langCookie !== undefined) {
      const idx = langCookie.search('uic');
      if (idx !== -1) {
        lang = langCookie.substr(idx + 4);
      }
    } else {
      Cookies.set('userCulture', 'c=is-IS|uic=is');
    }
    props.setLanguage(lang);
    moment.locale(lang);

    this.calculateHeight = this.calculateHeight.bind(this);

    this.state = {
      minHeight: visibleHeight
    };
  }

  getChildContext() {
    const { locale } = this.props;
    const newLocale = locale[locale.lang];
    newLocale['currentLang'] = locale.lang;
    return {
      locale: newLocale
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.calculateHeight);
    setTimeout(() => {
      this.calculateHeight(this.props);
    }, 10);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.calculateHeight);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.browser.height !== prevProps.browser.height ||
      this.props.browser.width !== prevProps.browser.width
    ) {
      this.calculateHeight();
    }

    if (prevProps.locale.lang !== this.props.locale.lang) {
      this.forceUpdate();
    }
  }

  calculateHeight() {
    let calculatedHeight = this.props.browser.height;
    const header = document.getElementById('main-header');
    const footer = document.getElementById('main-footer');
    if (header && footer) {
      calculatedHeight -= getElementHeight(header) + getElementHeight(footer);
    }
    this.setState({ minHeight: calculatedHeight });
  }

  render() {
    const { minHeight } = this.state;
    const { locale, sidebar, UserMenu } = this.props;

    if (!locale.loaded) return null;

    const rootCls = `thjonustuvefur ${sidebar.isOpen ? ' sidebar-on sidebar-open' : ''}`;
    return (
      <div className={rootCls} style={{ position: 'relative' }}>
        <div id="main-wrap" className="main-wrap">
          <div className="top-spacer" />

          <Header
            name={this.props.user}
            email={this.props.userSub}
            settingsUrl={this.props.settingsUrl}
            onSettingsClick={this.props.onSettingsClick}
            UserMenu={UserMenu}
            hinderNav={this.props.hinderNav}
          />
          <MainContent minHeight={minHeight}>{this.props.children}</MainContent>
          {!this.props.hinderNav && <Sidebar />}
          <Footer
            onContactClick={this.props.onContactClick}
            currentLang={this.props.locale.lang}
            setLanguage={this.props.setLanguage}
          />
        </div>
      </div>
    );
  }
}

Root.propTypes = {
  children: PropTypes.node,
  user: PropTypes.string,
  userSub: PropTypes.string,
  settingsUrl: PropTypes.string,
  sideNavProducts: PropTypes.array,
  onLogOutClick: PropTypes.func,
  footer: PropTypes.node,
  onSettingsClick: PropTypes.func
};

Root.childContextTypes = {
  locale: PropTypes.object
};

Root.defaultProps = {
  user: '',
  userSub: '',
  settingsUrl: `${process.env.REACT_APP_BUSINESS_WEB_URL}/Profile/MyUsageOverview.aspx`
};

const mapState = ({ locale, browser, sidebar }) => ({
  locale,
  browser,
  sidebar
});

const mapDispatch = dispatch => ({ setLanguage: bindActionCreators(setLanguage, dispatch) });

export default connect(mapState, mapDispatch)(Root);



// WEBPACK FOOTER //
// ./src/common/jsx/layout/Root.js